import React, { useEffect, useCallback, useState } from 'react';
import PalmistryHero from '../../components/palmistry101/PalmistryHero';
import PalmistryLearningOutcomes from '../../components/palmistry101/PalmistryLearningOutcomes';
import InteractiveHandStudy from '../../components/palmistry101/InteractiveHandStudy';
import PalmistryLessonAccordion from '../../components/palmistry101/PalmistryLessonAccordion';
import PalmistryPdfDownload from '../../components/palmistry101/PalmistryPdfDownload';
import PalmistryPhilosophy from '../../components/palmistry101/PalmistryPhilosophy';
import PalmistryCTA from '../../components/palmistry101/PalmistryCTA';
import PalmistryPrimaryCta from '../../components/palmistry101/PalmistryPrimaryCta';
import { PALMISTRY_CHECKOUT_URL, PALMISTRY_PDF_URL } from '../../data/palmistry101Content';
import { hasPalmistryAccess, applyPalmistryAccessFromUrl } from '../../lib/palmistry101Access';
import './Palmistry101Page.css';

const PAGE_TITLE = 'Palmistry 101 | Astral Moon Magic';

export default function Palmistry101Page() {
  const checkoutUrl = (PALMISTRY_CHECKOUT_URL || '').trim();
  const pdfUrl = (PALMISTRY_PDF_URL || '').trim();

  const [hasAccess, setHasAccess] = useState(() => hasPalmistryAccess());

  useEffect(() => {
    const prev = document.title;
    document.title = PAGE_TITLE;
    return () => {
      document.title = prev;
    };
  }, []);

  useEffect(() => {
    if (applyPalmistryAccessFromUrl()) {
      setHasAccess(true);
    }
  }, []);

  const scrollToPurchase = useCallback(() => {
    const el = document.getElementById('palmistry-purchase');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  return (
    <div className="amm-palmistry101">
      <div className="amm-palmistry101-shell">
        <PalmistryHero checkoutUrl={checkoutUrl} onPrimaryCta={scrollToPurchase} />

        <PalmistryLearningOutcomes />

        <section className="amm-palmistry101-section amm-palmistry101-hand-section" id="palmistry-interactive">
          <h2 className="amm-palmistry101-section-title">Interactive Hand Learning</h2>
          <p className="amm-palmistry101-hand-instruction">
            Select a line, mount, or area of the hand to explore how it is read.
          </p>
          <p className="amm-palmistry101-section-intro">
            {hasAccess
              ? 'Explore the major lines and mounts on the illustration. Choose a region for calm, practical guidance — then continue into the lesson flow below.'
              : 'Preview two sample areas on the hand. The full course unlocks every region, with the same unhurried pacing.'}
          </p>
          <InteractiveHandStudy
            hasFullAccess={hasAccess}
            onRequestPurchase={scrollToPurchase}
          />
        </section>

        <PalmistryPhilosophy />

        <PalmistryLessonAccordion hasFullAccess={hasAccess} />

        <PalmistryPdfDownload hasAccess={hasAccess} pdfUrl={pdfUrl} />

        <PalmistryCTA checkoutUrl={checkoutUrl} onCta={scrollToPurchase} />
      </div>

      <div className="amm-palmistry101-sticky-cta" role="region" aria-label="Course enrollment">
        <div className="amm-palmistry101-sticky-inner">
          <span className="amm-palmistry101-sticky-label">Palmistry 101</span>
          <PalmistryPrimaryCta
            checkoutUrl={checkoutUrl}
            onFallback={scrollToPurchase}
            className="amm-palmistry101-sticky-btn"
          />
        </div>
      </div>
    </div>
  );
}
